import { Tag, TagProps, Skeleton } from "@chakra-ui/react";
import { IssueId } from "models/issue";
import { PrefixId } from "features/Resources/Shared/models";
import { useIssueActionResolvedQuery } from "../hooks";

interface IssueActionStatusTagProps extends TagProps {
  issueId: IssueId;
  actionPrefixId: PrefixId;
}

export default function IssueActionStatusTag({ issueId, actionPrefixId, ...rest }: IssueActionStatusTagProps) {
  const { data, isLoading } = useIssueActionResolvedQuery(issueId, actionPrefixId);

  if (isLoading) {
    return <Skeleton height="20px" width="60px" />;
  }

  const isResolved = data?.resolved ?? false;

  return (
    <Tag
      colorScheme={isResolved ? "green" : "red"}
      size="sm"
      {...rest}
    >
      {isResolved ? "Resolved" : "Unresolved"}
    </Tag>
  );
}
